export enum MediaserverAudioSetting {
  MediaserverAudioDisabled = 'MediaserverAudioDisabled',
  MediaserverAudioEnabled = 'MediaserverAudioEnabled',
}
